<lib-map [includeSectionItems]="true"
[includeBasemap]="false"
[initialRotation]="4"
></lib-map>